
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"51","height":"53","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#005149","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M25.403 50.021c-13.034 0-23.638-10.604-23.638-23.637 0-13.034 10.604-23.638 23.638-23.638 13.033 0 23.637 10.604 23.637 23.638 0 13.033-10.604 23.637-23.637 23.637m0-49.04C11.395.98 0 12.376 0 26.384 0 40.39 11.395 51.786 25.403 51.786c14.007 0 25.403-11.395 25.403-25.402C50.806 12.376 39.41.98 25.403.98"}}),_c('path',{attrs:{"d":"M25.302 21.491c-.599 0-1.086.488-1.086 1.087v18.119a1.088 1.088 0 002.173 0v-18.12c0-.598-.487-1.086-1.087-1.086m0-8.819c-1.05 0-1.903.855-1.903 1.904 0 1.05.853 1.905 1.903 1.905s1.905-.855 1.905-1.905-.854-1.904-1.905-1.904","stroke":"#005149","stroke-width":".5"}})])])
          )
        }
      }
    